'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _support = require('helpers/support');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ServiceItemSmall = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ServiceItemSmall, _Component);

  function ServiceItemSmall(props) {
    (0, _classCallCheck3.default)(this, ServiceItemSmall);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ServiceItemSmall.__proto__ || (0, _getPrototypeOf2.default)(ServiceItemSmall)).call(this, props));

    _this.state = {
      showModal: false
    };

    _this.showDescModal = _this.showDescModal.bind(_this);
    _this.hideDescModal = _this.hideDescModal.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ServiceItemSmall, [{
    key: 'showDescModal',
    value: function showDescModal() {
      this.setState({ showModal: true });
    }
  }, {
    key: 'hideDescModal',
    value: function hideDescModal() {
      this.setState({ showModal: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.data;

      if (!data) return null;
      var showModal = this.state.showModal;
      var name = data.name,
          duration = data.duration,
          price = data.price,
          originalPrice = data.originalPrice,
          description = data.description;

      var styles = require('./ServiceCardBooking.scss');
      return _react2.default.createElement(
        'section',
        { className: styles.serviceCard },
        _react2.default.createElement(
          'div',
          { className: styles.groupTitle },
          !!name && _react2.default.createElement(
            'h2',
            null,
            name
          )
        ),
        !!duration && _react2.default.createElement(
          'span',
          { className: styles.duration },
          ' ',
          duration,
          ' ph\xFAt'
        ),
        _react2.default.createElement(
          'div',
          { className: styles.groupPrice },
          !!price && _react2.default.createElement(
            'p',
            { className: styles.newPrice },
            _support.Helper.formatMoney(price)
          ),
          !!originalPrice && _react2.default.createElement(
            'p',
            { className: styles.oldPrice },
            ' ',
            _support.Helper.formatMoney(originalPrice),
            ' '
          )
        ),
        !!description && _react2.default.createElement(
          _components.ModalCustom,
          {
            title: { text: name },
            closeButton: true,
            show: showModal,
            onHide: this.hideDescModal
          },
          _react2.default.createElement('div', {
            className: styles.modalDesc,
            dangerouslySetInnerHTML: { __html: description }
          })
        )
      );
    }
  }]);
  return ServiceItemSmall;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.object
}, _temp);
exports.default = ServiceItemSmall;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/ServiceCardBooking.js
// module id = 1569
// module chunks = 0